<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actuals - Vehicle Start/Stop Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report shows planned vs actual vehicle leave / arrival times for bookings finishing on the selected date.</span>
    </div>
    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;
      Type&nbsp;<b-form-select v-model="selected_type" :options="type_options" style="font-size: 20px; font-weight: bold; width:130px"/>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Run Report</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <div class="d-flex align-items-center justify-content-center">
        <b-button size="md" variant="success" @click="download">Download</b-button>
      </div>
    </div>
    <hr/>
    <div v-if="summary.total_cnt" style="font-weight: bold; font-size: 22px; margin: 20px" class="align-right d-flex align-items-center justify-content-center">
      <div v-if="summary.total_cnt" class="col2" style="border: 1px solid grey; padding-right: 15px; padding-left: 15px; margin-right:30px">Results: {{items.length}} of {{summary.total_cnt}}</div>
      Filter: &nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="charterID,vehicle,driver"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Start Early/Late Limits:&nbsp;<b-form-select v-model="start_early_threshold" :options="el_threshold_options" style="background-color: hsla(120,100%,75%,0.2);font-size: 20px; font-weight: bold; width:85px"/>
      &nbsp;<b-form-select v-model="start_late_threshold" :options="el_threshold_options" class="late" style="background-color: rgba(255,0,0,0.2);font-size: 20px; font-weight: bold; width:85px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Finish Early/Late Limits:&nbsp;<b-form-select v-model="finish_early_threshold" :options="el_threshold_options" style="background-color: hsla(120,100%,75%,0.2); font-size: 20px; font-weight: bold; width:85px"/>
      &nbsp;<b-form-select v-model="finish_late_threshold" :options="el_threshold_options" class="late" style="background-color: rgba(255,0,0,0.2); font-size: 20px; font-weight: bold; width:85px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
        Time Diff &nbsp;<b-form-select v-model="time_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
    </div>
    <div v-if="summary.views_reports_vehicle_report_start_offset_minutes || summary.views_reports_vehicle_report_finish_offset_minutes || summary.views_reports_vehicle_report_round_to_minutes" class="row" style="margin-bottom:20px; font-weight: bold; font-size: 22px;">
      <div class="col" style="border: 1px solid grey;">Calculated Time Rules</div>
      <div class="col" style="border: 1px solid grey;" v-if="summary.views_reports_vehicle_report_start_threshold_minutes">Start Threshold: {{summary.views_reports_vehicle_report_start_threshold_minutes}}m</div>
      <div class="col" style="border: 1px solid grey;" v-if="summary.views_reports_vehicle_report_start_min_planned">Start Min Planned: {{summary.views_reports_vehicle_report_start_min_planned}}</div>
      <div class="col" style="border: 1px solid grey;" v-if="summary.views_reports_vehicle_report_start_offset_minutes">Start Offset: {{summary.views_reports_vehicle_report_start_offset_minutes}}m</div>
      <div class="col" style="border: 1px solid grey;" v-if="summary.views_reports_vehicle_report_finish_offset_minutes">Finish Offset: {{summary.views_reports_vehicle_report_finish_offset_minutes}}m</div>
      <div class="col" style="border: 1px solid grey;" v-if="summary.views_reports_vehicle_report_round_to_minutes">Round To Nearest: {{summary.views_reports_vehicle_report_round_to_minutes}}m</div>
    </div>

    <table v-if="items.length > 0 && !loading" width="100%" border="1" cellpadding="2">
      <tr>
        <th v-if="show_col('booking_type')" width="60px" @click="sort_strings('booking_type')">Type</th>
        <th v-if="show_col('charterID')" width="60px" @click="sort_numbers('charterID')">CharterID</th>
        <th v-if="show_col('movementID')" width="60px" @click="sort_numbers('movementID')">MvmtID</th>
        <th v-if="show_col('vehicle')" width="60px" @click="sort_strings('vehicle')">Vehicle</th>
        <th v-if="show_col('driver')" width="60px" @click="sort_strings('driver')">Driver</th>
        <th v-if="show_col('plannedStartDateTime')" width="60px" @click="sort_dates('plannedStartDateTime')">Planned Start</th>
        <th v-if="show_col('origStartDateTime')" width="60px" @click="sort_dates('origStartDateTime')">Actual Start</th>
        <th v-if="show_col('actualStartDateTime') && summary.views_reports_vehicle_report_calcs_enabled" width="60px" @click="sort_dates('actualStartDateTime')">Calculated Start</th>
        <th v-if="show_col('startDelta')" width="30px" @click="sort_numbers('startDelta')">Start Diff</th>
        <th v-if="show_col('plannedFinishDateTime')" width="60px" @click="sort_dates('plannedFinishDateTime')">Planned Finish</th>
        <th v-if="show_col('origFinishDateTime')" width="60px" @click="sort_dates('origFinishDateTime')">Actual Finish</th>
        <th v-if="show_col('actualFinishDateTime') && summary.views_reports_vehicle_report_calcs_enabled" width="60px" @click="sort_dates('actualFinishDateTime')">Calculated Finish</th>
        <th v-if="show_col('finishDelta')" width="30px" @click="sort_numbers('finishDelta')">Finish Diff</th>
      </tr>
      <template v-for="item in items">
        <tr>
          <td v-if="show_col('booking_type')" align="center">{{ item.booking_type }}</td>
          <td v-if="show_col('charterID')" align="center">{{ item.charterID }}</td>
          <td v-if="show_col('movementID')" align="center">
            <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + item.booking_hash }">{{ item.movementID }}</router-link>
          </td>
          <td v-if="show_col('vehicle')" align="center">{{ item.vehicle }}</td>
          <td v-if="show_col('driver')" align="center">{{ item.driver }}</td>
          <td v-if="show_col('plannedStartDateTime')">{{item.plannedStartDateTime | formatDateTimeSmall}}</td>
          <td v-if="show_col('origStartDateTime')">{{item.origStartDateTime | formatDateTimeSmall}}</td>
          <td v-if="show_col('actualStartDateTime') && summary.views_reports_vehicle_report_calcs_enabled">{{item.actualStartDateTime | formatDateTimeSmall}}</td>
          <template v-if="show_col('startDelta')">
            <td v-if="item.startDelta < (-1 * start_early_threshold)" class="early">{{item.startDelta | units('m')}}</td>
            <td v-else-if="item.startDelta > start_late_threshold" class="late">{{item.startDelta | units('m')}}</td>
            <td v-else-if="item.startDelta">{{item.startDelta | units('m')}}</td>
            <td v-else>&nbsp;</td>
          </template>
          <td v-if="show_col('plannedFinishDateTime')">{{item.plannedFinishDateTime | formatDateTimeSmall}}</td>
          <td v-if="show_col('origFinishDateTime')">{{item.origFinishDateTime | formatDateTimeSmall}}</td>
          <td v-if="show_col('actualFinishDateTime') && summary.views_reports_vehicle_report_calcs_enabled">{{item.actualFinishDateTime | formatDateTimeSmall}}</td>
          <template v-if="show_col('finishDelta')">
            <td v-if="item.finishDelta < (-1 * finish_early_threshold)" class="early">{{item.finishDelta | units('m')}}</td>
            <td v-else-if="item.finishDelta > finish_late_threshold" class="late">{{item.finishDelta | units('m')}}</td>
            <td v-else-if="item.finishDelta">{{item.finishDelta | units('m')}}</td>
            <td v-else>&nbsp;</td>
          </template>
        </tr>
      </template>
    </table>
    <div v-else-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_actuals_vehicle_report, save_event_notes} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_vehicle_report',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      summary: [],
      time_threshold: null,
      miles_threshold: null,
      selected_type: '',
      selected_status: null,
      start_early_threshold: 30,
      start_late_threshold: 30,
      finish_early_threshold: 60,
      finish_late_threshold: 60,
      el_threshold_options: [
        { value: '1', text: '1m' },
        { value: '5', text: '5m' },
        { value: '10', text: '10m' },
        { value: '15', text: '15m' },
        { value: '20', text: '20m' },
        { value: '30', text: '30m' },
        { value: '45', text: '45m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
      ],
      type_options: [
        { value: '', text: 'All' },
        { value: 'contract', text: 'Contract' },
        { value: 'private', text: 'Private' },
      ],
      threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10m' },
        { value: '15', text: '> 15m' },
        { value: '30', text: '> 30m' },
        { value: '45', text: '> 45m' },
        { value: '60', text: '> 60m' },
        { value: '120', text: '> 120m' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {

  },
  methods: {
    show_col(col) {
       if (this.summary.views_reports_vehicle_report_start_stop_columns) {
         return this.summary.views_reports_vehicle_report_start_stop_columns.indexOf(col) != -1;
       } else {
         return true;
       }
    },
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_actuals_vehicle_report(this.user.tenant, this.selected_type, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async save_notes(item) {
      try {
        let json = {
          'event_hash': item.event_notes_hash,
          'notes': item.event_notes
        }
        const {value: { data = [] } } = await save_event_notes(this.user.tenant, json)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => (item.charterID.indexOf(this.booking_filter) != -1 || (item.driver != null && item.driver.indexOf(this.booking_filter) != -1) || (item.vehicle != null && item.vehicle.indexOf(this.booking_filter) != -1)))
      if (this.time_threshold)
        this.items = this.items.filter(item => (Math.abs(item.startDelta) > this.time_threshold || Math.abs(item.finishDelta) > this.time_threshold))
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/actuals/vehicle/download`,
          {
            tenant: this.user.tenant,
            booking_type: this.selected_type,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `vehicle-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    time_threshold(val) {
      this.filter_items()
    },
    miles_threshold(val) {
      this.filter_items()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}
.arrows {font-size: 22px; font-weight: bold; color: steelblue !important }

.col2 { border-radius: 5px; margin:2px; padding: 0px 8px 0px 8px;}

</style>
